module.exports = __webpack_public_path__ + "assets/img/组 68.d4e12cc4.png";